<form *ngIf="form" action="" class="menu-input" [formGroup]="form" [ngClass]="{'disabled': disabled}">
  <mat-form-field
    class="dn-menu-input-full-width"
    [matMenuTriggerFor]=" menuData && menuData.length  ? menu  : emptyMenu"
    (onMenuOpen)="toggleArrow(true)"
    (onMenuClose)="toggleArrow(false)"

  >

    <mat-label  class="dn-input-label ">{{placeholder}}</mat-label>
    <input
      class="dn-menu-input-field"
      type="text"
      matInput
      [readonly]="true"
      [formControlName]="formControlName"
    >
    <img class="dn-menu-icon suffix-icon arrow-icon" matSuffix   alt="" [src]="arrowDirection">


    <img
      *ngIf="this.form.get(formControlName).dirty && !hideValidIcon && !disabled"
      class="dn-menu-icon dn-menu-input-status-indicator"
      matSuffix
      alt=""
      [src]="this.form.get(formControlName).valid ? validIconUrl : inValidIconUrl"
      [ngClass]="{'error-indicator': !this.form.get(formControlName).valid }">


    <img *ngIf="_prefixIcon" class="dn-prefix-menu-item" matPrefix [src]="_prefixIcon" />

  </mat-form-field>

</form>
<mat-menu #menu [classList]="'dn-menu'" [overlapTrigger]="false" [backdropClass]="'billing-country'" [yPosition]="menuPosition" >
  @for (c of menuData; track c) {
    <button mat-menu-item (click)="updateForm(c)">{{c.key}}</button>
  }
</mat-menu>

<mat-menu #emptyMenu [classList]="'dn-menu'" [overlapTrigger]="false" [backdropClass]="'billing-country'">
  <button mat-menu-item>No States Available</button>
</mat-menu>
